/* istanbul ignore file */
import { array as codecArray, number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { NormalUser } from './NormalUser';
const GroupParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['members', /* #__PURE__ */ codecArray(NormalUser)],
    ['name', codecString],
    ['groupSetId', codecNumber, 'group_set_id'],
    ['createdAt', parsers.moment, 'created_at'],
]);
export class Group extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GroupParser.decode(input).map(res => new Group(res));
    }
    static unsafeDecode(input) {
        return Group.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GroupParser.encode(data);
    }
    static schema() {
        return GroupParser.schema();
    }
}
